import * as React from 'react';
import {Box, Typography, Slider} from '@mui/material';
import {wordsToCapitalizedCase} from '../../utils/miscellaneous';

/**
 * Symptom
 * Element to display symptom checker data or dermadetect data(in the future it could emcompass more API services). It assumes it is displaying a percentage and therefore ouputs a horizontal line with another one above it representing the percentage completed as the value
 *
 * @param {Object} props - Component props
 * @param {string} props.name - main text to be displayed
 * @param {Number} props.result - Number from 0 to 100 representing a percent
 * @param {string} props.symptomColour - valid string representing a colour
 *
 * @returns {React.Component} Rendered Component
 */
export const Symptom = ({name, result, symptomColour}) => {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        width: '100%',
        columnGap: 3,
        mt: 1,
      }}
    >
      <Box flexGrow={1}>
        <Typography variant="subtitle1" sx={{fontWeight: 'bold', fontSize: '18px'}}>
          {wordsToCapitalizedCase(name)}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: {
              xs: 2,
              md: 4,
            },
          }}
        >
          <Slider value={result} sx={{color: symptomColour}} />
          <Typography
            variant="h5"
            sx={{
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {Math.round(result).toFixed(0)}%
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
